module.exports = __webpack_public_path__ + "img/fire-flame-05.2d441302.png";